// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__ZwBCM","head":"Table_head__3a71O","col":"Table_col__hegBH"};